import { ConfirmDialog } from '@/components/dialogs/ConfirmDialog';
import { useClientSchemaContext } from '@/context/clientSchemaContext';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { VIEW_TYPES } from '@/features/config/helper';
import {
	useDeleteContactMutation,
	useUpdateContactMutation,
} from '@/features/contacts/contactsApi';
import { Box, Button } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const RemoveContactButton = ({ index }) => {
	const params = useParams();
	const { values, setFieldValue } = useFormikContext();
	const { view } = useClientSchemaContext();
	const dialogData = useSelector((state) => state.dialog);

	const clientId = params?.clientId ?? dialogData?.data?.clientDialog?.clientId;

	const [dialogOpen, setDialogOpen] = useState(false);
	const handleOpenDialog = () => setDialogOpen(true);
	const handleCloseDialog = () => setDialogOpen(false);

	const [updateContact, contactState] = useUpdateContactMutation();
	const [deleteContact, deleteContactState] = useDeleteContactMutation();

	const disabled =
		contactState.isLoading ||
		(values.contacts?.[index]?.isMainContact && (values.contacts ?? []).length <= 1);

	const { currentData: clientRow } = useGetClientRowQuery(clientId, {
		skip: view === VIEW_TYPES.create || !clientId,
	});

	const handleConfirmDialog = async () => {
		try {
			const contact = values.contacts[index];
			const isRemovingMainContact = contact.isMainContact;
			let newMainContact;
			if (isRemovingMainContact) {
				newMainContact = values.contacts.find((c) => c.Id !== contact.Id);
				if (newMainContact) {
					// Promotes another contact
					const newMainContactRes = await updateContact({
						insightId: newMainContact.Id,
						clientId: clientRow?.clientId,
						isMainContact: true,
					}).unwrap();
					console.log('Updated new main contact', newMainContactRes);
				}
			}
			const contactRes = await deleteContact({
				insightId: contact.Id,
				clientId: clientRow?.clientId,
			}).unwrap();
			console.log('Deleted old contact', contactRes);

			const newContacts = values.contacts
				.filter((_, i) => i !== index)
				.map((c) => (c.Id === newMainContact?.Id ? { ...c, isMainContact: true } : c));
			setFieldValue('contacts', newContacts);

			handleCloseDialog();
			setTimeout(() => window.scrollTo(0, 0), 100);
		} catch (err) {
			console.error('Error removing association:', err);
		}
	};

	return (
		<>
			{view !== VIEW_TYPES.create && (
				<>
					<Box>
						<Button size='small' disabled={disabled} onClick={handleOpenDialog}>
							Remove
						</Button>
					</Box>
					<ConfirmDialog
						openDialog={dialogOpen}
						handleClose={handleCloseDialog}
						handleConfirm={handleConfirmDialog}
						canBeUndone={true}
						actionName={'remove'}
						additionalContent={
							'The contact will no longer be associated with this client.'
						}
					/>
				</>
			)}
		</>
	);
};
export default RemoveContactButton;
